import axios from "axios";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { API } from "@/lib/api";

const KEY = "obt_admin_token";
export const getToken = () => localStorage.getItem(KEY);
export const setToken = (t) => (t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY));

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((c) => {
  const t = getToken();
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
adminApi.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config.url.includes("/auth/login")) {
      setToken(null);
      if (!window.location.pathname.startsWith("/admin/login")) window.location.href = "/admin/login";
    }
    return Promise.reject(e);
  },
);

export const useAdmin = (path, opts = {}) =>
  useQuery({ queryKey: ["admin", path], queryFn: () => adminApi.get(path).then((r) => r.data), ...opts });

export const useRefresh = () => {
  const qc = useQueryClient();
  return (prefix) => qc.invalidateQueries({ predicate: (q) => q.queryKey[0] === "admin" && (!prefix || String(q.queryKey[1]).startsWith(prefix)) });
};

export const downloadBlob = async (path, filename, params) => {
  const r = await adminApi.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const slugify = (s) => s.toLowerCase().trim().replace(/[^a-z0-9\s-]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, "");

export const fmtDate = (iso, time = true) =>
  iso ? new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", ...(time ? { hour: "2-digit", minute: "2-digit" } : {}) }) : "-";
